import { cn } from '@/lib/utils';
import { Bot} from 'lucide-react';

const AssistantThinkingLoader = () => (
  <div
    role="status"
    aria-live="polite"
    aria-label="Assistant is preparing a response"
    className={cn(
      'mr-auto max-w-[90%] rounded-2xl border border-solid border-[var(--inv-border)]',
      'bg-[var(--inv-surface)] px-4 py-3',
    )}>
    <div className="flex items-center gap-2.5">
      <span className="flex items-center gap-1" aria-hidden>
        <Bot className="h-4 w-4 text-[var(--inv-accent)]" />
        <span className="assistant-thinking-dot" />
        <span className="assistant-thinking-dot" />
        <span className="assistant-thinking-dot" />
      </span>
    </div>
    <div className="mt-3 flex flex-col gap-2" aria-hidden>
      <span className="assistant-thinking-bar h-2.5 w-[14rem] max-w-full" />
      <span className="assistant-thinking-bar h-2.5 w-[10.5rem] max-w-[80%]" />
    </div>
  </div>
);

export default AssistantThinkingLoader;
